import React, {useState, useEffect} from 'react';
import { notification } from '../../hocs/notification';

import axios from 'axios';
import { mainurl } from '../../../Mainurl';

import { 
    Row, 
    Col, 
    Card, 
    CardBody, 
    CardHeader, 
    Input, 
    Label, 
    Button, 
    Form, 
    Modal, 
    ModalHeader, 
    ModalBody, 
    Spinner,
    Badge,
    Alert,
    Progress
} from 'reactstrap';

import MonitoringHeader from './MonitoringHeader';
import MonitoringHeaderDtl from './MonitoringHeaderDtl';

import { 
    FaPlusCircle, 
    FaArrowLeft, 
    FaSeedling, 
    FaCalendarAlt,
    FaListAlt,
    FaRuler,
    FaWeight,
    FaFlask,
    FaChartLine,
    FaEdit,
    FaTrashAlt,
    FaPlus,
    FaClipboardList
} from 'react-icons/fa';

const AddNewPOP = ({data, back, ...props}) => {

    const [loading, setLoading] = useState(false);
    const [submitting, setSubmitting] = useState(false);

    const [cropTypeOpt, setCropTypeOpt] = useState('');
    const [cropType, setCropType] = useState('');
    const [cropOpt, setCropOpt] = useState('');
    const [crop, setCrop] = useState('');
    const [cropVarietyOpt, setCropVarietyOpt] = useState('');
    const [cropVariety, setCropVariety] = useState('');
    const [popDays, setPopDays] = useState('');
    
    const [measureHeaderOpt, setMeasureHeaderOpt] = useState('');
    const [measureDetailOpt, setMeasureDetailOpt] = useState('');

    // header
    const [measureHeader, setMeasureHeader] = useState('');
    const [measureHeaderTxt, setMeasureHeaderTxt] = useState('');
    const [seqNumber, setSeqNumber] = useState('');
    const [seqDay, setSeqDay] = useState('');
    // details
    const [measureDtl, setMeasureDtl] = useState('');
    const [measureDtlTxt, setMeasureDtlTxt] = useState('');
    const [rmdValue, setRmdValue] = useState('');
    const [rmdUom, setRmdUom] = useState('');
    const [rmdUomTxt, setRmdUomTxt] = useState('');
    
    const [currMcode, setCurrMcode] = useState('');
    const [popDataHtml, setPopDataHtml] = useState([]);

    const [headerModal, setHeaderModal] = useState(false);
    const [editHeaderFlag, setEditHeaderFlag] = useState(false);
    const [detailModal, setDetailModal] = useState(false);
    const [editDetailFlag, setEditDetailFlag] = useState(false);

    // Statistics
    const [stats, setStats] = useState({
        totalHeaders: 0,
        totalDetails: 0,
        completionPercentage: 0
    });

    useEffect(() => {
        get_measure_header_list();
        get_pop_details();
    }, []);

    const get_pop_details = async () => {
        setLoading(true);
        try {
            let postData = [{
                "org_id": data.org_id,
                "org_pop_code": data.org_pop_code,
                "crop_code": data.crop_code,
                "crop_variety_code": data.crop_variety_code
            }];

            const response = await axios({
                method: 'post',
                url: mainurl + 'Traceability/get_pop_details',
                data: postData,
                headers: { 'Content-Type': 'application/JSON', }
            });

            let totalDetails = 0;
            let list = response.data.map((row, index) => {
                totalDetails += row.monitoring_detail?.length || 0;
                return(
                    <MonitoringHeader 
                        key={index}
                        data={row} 
                        delete_h={() => delete_header(index)} 
                        edit_h={() => edit_header(row)} 
                        add_details={() => {
                            setDetailModal(true); 
                            setEditDetailFlag(false);
                            setCurrMcode(row.m_code); 
                            get_measure_detail_list(row.m_code);
                        }}
                    >
                        {row.monitoring_detail?.map((row1, index1) => {
                            return (
                                <MonitoringHeaderDtl 
                                    key={index1}
                                    data={row1} 
                                    delete_d={() => delete_detail(index, index1)} 
                                    edit_d={() => {
                                        edit_detail(row1);
                                        setCurrMcode(row.m_code);
                                        get_measure_detail_list(row.m_code);
                                    }} 
                                />
                            )
                        })}
                    </MonitoringHeader>
                )
            });

            setPopDataHtml(list);
            
            // Update statistics
            setStats({
                totalHeaders: response.data.length,
                totalDetails: totalDetails,
                completionPercentage: response.data.length > 0 ? Math.round((totalDetails / (response.data.length * 5)) * 100) : 0
            });

        } catch (error) {
            let notify = notification({ 
                message: "Failed to load POP details. Please try again.", 
                type: 'error' 
            });
            notify();
        } finally {
            setLoading(false);
        }
    }

    const get_measure_header_list = async () => {
        try {
            const response = await axios({
                method: 'post',
                url: mainurl + 'Master/get_measure_h_list',
                headers: { 'Content-Type': 'application/JSON', }
            });

            let list = response.data.map((row, index) => {
                return (
                    <option key={index} value={row.m_code}>{row.m_desc}</option>
                )
            });

            setMeasureHeaderOpt(list);
        } catch (error) {
            let notify = notification({ 
                message: "Failed to load measure headers.", 
                type: 'error' 
            });
            notify();
        }
    }

    const get_measure_detail_list = async (code) => {
        try {
            let postData = [{"m_code": code}];
            const response = await axios({
                method: 'post',
                url: mainurl + 'Master/get_measure_d_list',
                data: postData,
                headers: { 'Content-Type': 'application/JSON', }
            });

            let list = response.data.map((row, index) => {
                return (
                    <option key={index} value={row.md_code}>{row.m_desc}</option>
                )
            });

            setMeasureDetailOpt(list);
        } catch (error) {
            let notify = notification({ 
                message: "Failed to load measure details.", 
                type: 'error' 
            });
            notify();
        }
    }

    const add_monitoring_header_handler = async (e) => {
        e.preventDefault();
        setSubmitting(true);
        
        try {
            let postData = [{
                "org_id": data.org_id,
                "m_code": measureHeader,
                "m_seq_no": seqNumber,
                "m_seq_day": seqDay,
                "org_pop_code": data.org_pop_code,
                "crop_code": data.crop_code,
                "crop_variety_code": data.crop_variety_code,
            }];

            const response = await axios({
                method: 'post',
                url: mainurl + 'Traceability/create_pop_header',
                data: postData,
                headers: { 'Content-Type': 'application/JSON', }
            });

            if(response.data[0].retcode === "101"){
                let notify = notification({ 
                    message: "POP header created successfully.", 
                    type: 'success', 
                    time: true, 
                    position: 'center' 
                });
                notify();
                get_pop_details();
                setHeaderModal(false);
                resetHeaderForm();
            }
        } catch (error) {
            let notify = notification({ 
                message: "Failed to create POP header. Please try again.", 
                type: 'error' 
            });
            notify();
        } finally {
            setSubmitting(false);
        }
    }

    const add_monitoring_detail_handler = async (e) => {
        e.preventDefault();
        setSubmitting(true);
        
        try {
            let postData = [{
                "org_id": data.org_id,
                "m_code": currMcode,
                "md_code": measureDtl,
                "recommend_value": rmdValue,
                "recommend_uom": rmdUom,
                "org_pop_code": data.org_pop_code,
                "crop_code": data.crop_code,
                "crop_variety_code": data.crop_variety_code,
            }];

            const response = await axios({
                method: 'post',
                url: mainurl + 'Traceability/create_pop_detail',
                data: postData,
                headers: { 'Content-Type': 'application/JSON', }
            });

            if(response.data[0].retcode === "101"){
                let notify = notification({ 
                    message: "Detail added successfully.", 
                    type: 'success', 
                    time: true, 
                    position: 'center' 
                });
                notify();
                get_pop_details();
                setDetailModal(false);
                resetDetailForm();
            }
        } catch (error) {
            let notify = notification({ 
                message: "Failed to add detail. Please try again.", 
                type: 'error' 
            });
            notify();
        } finally {
            setSubmitting(false);
        }
    }

    const resetHeaderForm = () => {
        setMeasureHeader('0');
        setSeqNumber('');
        setSeqDay('');
        setMeasureHeaderTxt('');
    }

    const resetDetailForm = () => {
        setMeasureDtl('0');
        setRmdValue('');
        setRmdUom('');
        setMeasureDtlTxt('');
        setRmdUomTxt('');
    }

    const edit_header = () => {
        // Implementation for edit header
    }

    const update_edit_header = () => {
        // Implementation for update edit header
    }

    const edit_detail = (dtl) => {
        // Implementation for edit detail
    }

    const update_edit_detail = () => {
        // Implementation for update edit detail
    }

    const delete_header = (id) => {
        // Implementation for delete header
    }

    const delete_detail = (id, id1) => {
        // Implementation for delete detail
    }

    const getUomIcon = (uom) => {
        switch(uom) {
            case '1': case '2': return <FaWeight className="text-warning" />;
            case '3': return <FaFlask className="text-info" />;
            case '4': case '5': return <FaRuler className="text-primary" />;
            case '6': return <FaSeedling className="text-success" />;
            case '7': return <FaChartLine className="text-danger" />;
            default: return <FaListAlt className="text-muted" />;
        }
    }

    return(
        <>
            <Row className="p-3">
                <Col xs={12}>
                    {/* Header Card with Crop Information */}
                    <Card className='mb-4 border-0 shadow-sm'>
                        <CardHeader className='bg-primary text-white d-flex justify-content-between align-items-center'>
                            <div className="d-flex align-items-center gap-2">
                                <FaClipboardList size={20} />
                                <h5 className="mb-0">Package of Practice Details</h5>
                            </div>
                            <Button 
                                color='light' 
                                size="sm" 
                                onClick={back}
                                className="d-flex align-items-center gap-2"
                            >
                                <FaArrowLeft size={14} />
                                Back to List
                            </Button>
                        </CardHeader>
                        <CardBody>
                            <Row className="align-items-center">
                                <Col md={4}>
                                    <div className="d-flex align-items-center gap-2 mb-2">
                                        <FaSeedling className="text-success" size={18} />
                                        <strong>Crop Details</strong>
                                    </div>
                                    <div className="text-muted">
                                        <strong className="text-primary">{data?.crop_name}</strong>
                                        <br />
                                        <small>Variety: {data?.crop_variety_name}</small>
                                    </div>
                                </Col>
                                <Col md={2}>
                                    <div className="d-flex align-items-center gap-2 mb-2">
                                        <FaCalendarAlt className="text-warning" size={16} />
                                        <strong>POP Days</strong>
                                    </div>
                                    <Badge color="info" pill className="fs-6">
                                        {data?.pop_days} Days
                                    </Badge>
                                </Col>
                                <Col md={3}>
                                    <div className="mb-2">
                                        <strong>Completion Progress</strong>
                                    </div>
                                    <Progress 
                                        value={stats.completionPercentage} 
                                        color={stats.completionPercentage > 75 ? 'success' : stats.completionPercentage > 50 ? 'warning' : 'danger'}
                                        className="mb-1"
                                    />
                                    <small className="text-muted">{stats.completionPercentage}% Complete</small>
                                </Col>
                                <Col md={3} className="text-end">
                                    <Button 
                                        color='primary' 
                                        size="sm" 
                                        onClick={() => {setHeaderModal(true); setEditHeaderFlag(false);}}
                                        className="d-flex align-items-center gap-2"
                                    >
                                        <FaPlusCircle size={16} />
                                        Add Monitoring Header
                                    </Button>
                                </Col>
                            </Row>
                        </CardBody>
                    </Card>

                    {/* Statistics Cards */}
                    <Row className="mb-4">
                        <Col md={4}>
                            <Card className="border-0 bg-primary text-white">
                                <CardBody className="text-center py-3">
                                    <FaListAlt size={24} className="mb-2" />
                                    <h4 className="mb-0">{stats.totalHeaders}</h4>
                                    <small>Monitoring Headers</small>
                                </CardBody>
                            </Card>
                        </Col>
                        <Col md={4}>
                            <Card className="border-0 bg-success text-white">
                                <CardBody className="text-center py-3">
                                    <FaClipboardList size={24} className="mb-2" />
                                    <h4 className="mb-0">{stats.totalDetails}</h4>
                                    <small>Detail Records</small>
                                </CardBody>
                            </Card>
                        </Col>
                        <Col md={4}>
                            <Card className="border-0 bg-info text-white">
                                <CardBody className="text-center py-3">
                                    <FaChartLine size={24} className="mb-2" />
                                    <h4 className="mb-0">{stats.completionPercentage}%</h4>
                                    <small>Progress</small>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>

                    {/* POP Data Display */}
                    {loading ? (
                        <Card className="border-0 shadow-sm">
                            <CardBody className="text-center py-5">
                                <Spinner color="primary" className="mb-3" />
                                <p className="text-muted">Loading POP details...</p>
                            </CardBody>
                        </Card>
                    ) : popDataHtml.length > 0 ? (
                        <div className="monitoring-data">
                            {popDataHtml}
                        </div>
                    ) : (
                        <Alert color="info" className="text-center">
                            <FaClipboardList size={48} className="mb-3 text-muted" />
                            <h5>No Monitoring Headers Added Yet</h5>
                            <p className="mb-3">Start building your Package of Practice by adding monitoring headers and their details.</p>
                            <Button 
                                color="primary" 
                                onClick={() => {setHeaderModal(true); setEditHeaderFlag(false);}}
                                className="d-flex align-items-center gap-2 mx-auto"
                            >
                                <FaPlusCircle />
                                Add First Header
                            </Button>
                        </Alert>
                    )}
                </Col>
            </Row>

            {/* Enhanced Header Modal */}
            <Modal
                centered
                scrollable
                size="lg"
                isOpen={headerModal}
                toggle={() => setHeaderModal(!headerModal)}
                className="modal-dialog-scrollable"
            >
                <ModalHeader 
                    toggle={() => setHeaderModal(!headerModal)}
                    className="bg-light border-bottom"
                >
                    <div className="d-flex align-items-center gap-2">
                        <FaPlusCircle className="text-primary" />
                        <div>
                            <h5 className="mb-0">Add Monitoring Header</h5>
                            <small className="text-muted">Define a new monitoring parameter for this POP</small>
                        </div>
                    </div>
                </ModalHeader>
                <ModalBody className="p-4">
                    <Form onSubmit={add_monitoring_header_handler}>
                        <Row>
                            <Col md={12} className="mb-3">
                                <Label for="measureHeader" className="form-label fw-semibold">
                                    <FaListAlt className="me-2 text-primary" />
                                    Measuring Header Name
                                </Label>
                                <Input 
                                    id="measureHeader" 
                                    bsSize="sm" 
                                    type="select" 
                                    value={measureHeader} 
                                    onChange={(e) => { 
                                        setMeasureHeader(e.target.value); 
                                        setMeasureHeaderTxt(e.target.selectedOptions[0].text) 
                                    }}
                                    className="form-select"
                                >
                                    <option value="0">--Select Measure Header Name--</option>
                                    {measureHeaderOpt}
                                </Input>
                            </Col>
                            <Col md={6} className="mb-3">
                                <Label for="seqNumber" className="form-label fw-semibold">
                                    <FaListAlt className="me-2 text-info" />
                                    Sequence Number
                                </Label>
                                <Input 
                                    id="seqNumber" 
                                    bsSize="sm" 
                                    type="number" 
                                    value={seqNumber} 
                                    onChange={(e) => setSeqNumber(e.target.value)}
                                    placeholder="Enter sequence number"
                                    min="1"
                                />
                            </Col>
                            <Col md={6} className="mb-3">
                                <Label for="seqDay" className="form-label fw-semibold">
                                    <FaCalendarAlt className="me-2 text-warning" />
                                    Sequence Day
                                </Label>
                                <Input 
                                    id="seqDay" 
                                    bsSize="sm" 
                                    type="number" 
                                    value={seqDay} 
                                    onChange={(e) => setSeqDay(e.target.value)}
                                    placeholder="Enter day number"
                                    min="1"
                                    max={data?.pop_days || 365}
                                />
                            </Col>
                        </Row>
                        <hr className="my-4" />
                        <div className="d-flex justify-content-end gap-2">
                            <Button 
                                type="button"
                                color="secondary" 
                                size="sm"
                                onClick={() => setHeaderModal(false)}
                                disabled={submitting}
                            >
                                Cancel
                            </Button>
                            <Button 
                                type="submit"
                                color='primary' 
                                size="sm"
                                disabled={submitting || !measureHeader || measureHeader === '0' || !seqNumber || !seqDay}
                                className="d-flex align-items-center gap-2"
                            >
                                {submitting ? (
                                    <>
                                        <Spinner size="sm" />
                                        Adding...
                                    </>
                                ) : (
                                    <>
                                        <FaPlus size={14} />
                                        Add Header
                                    </>
                                )}
                            </Button>
                        </div>
                    </Form>
                </ModalBody>
            </Modal>

            {/* Enhanced Detail Modal */}
            <Modal
                centered
                scrollable
                size="lg"
                isOpen={detailModal}
                toggle={() => setDetailModal(!detailModal)}
                className="modal-dialog-scrollable"
            >
                <ModalHeader 
                    toggle={() => setDetailModal(!detailModal)}
                    className="bg-light border-bottom"
                >
                    <div className="d-flex align-items-center gap-2">
                        <FaClipboardList className="text-success" />
                        <div>
                            <h5 className="mb-0">Add Monitoring Details</h5>
                            <small className="text-muted">Add specific measurements and recommendations</small>
                        </div>
                    </div>
                </ModalHeader>
                <ModalBody className="p-4">
                    <Form onSubmit={add_monitoring_detail_handler}>
                        <Row>
                            <Col md={12} className="mb-3">
                                <Label for="measureDtl" className="form-label fw-semibold">
                                    <FaListAlt className="me-2 text-success" />
                                    Measuring Detail Name
                                </Label>
                                <Input 
                                    id="measureDtl" 
                                    bsSize="sm" 
                                    type="select" 
                                    value={measureDtl} 
                                    onChange={(e) => {
                                        setMeasureDtl(e.target.value); 
                                        setMeasureDtlTxt(e.target.selectedOptions[0].text)
                                    }}
                                    className="form-select"
                                >
                                    <option value="0">--Select Measure Detail Name--</option>
                                    {measureDetailOpt}
                                </Input>
                            </Col>
                            <Col md={6} className="mb-3">
                                <Label for="recomValue" className="form-label fw-semibold">
                                    <FaChartLine className="me-2 text-info" />
                                    Recommended Value
                                </Label>
                                <Input 
                                    id="recomValue" 
                                    bsSize="sm" 
                                    type="text" 
                                    value={rmdValue} 
                                    onChange={(e) => setRmdValue(e.target.value)}
                                    placeholder="Enter recommended value"
                                />
                            </Col>
                            <Col md={6} className="mb-3">
                                <Label for="recomUom" className="form-label fw-semibold">
                                    <FaRuler className="me-2 text-warning" />
                                    Unit of Measurement
                                </Label>
                                <Input 
                                    id="recomUom" 
                                    bsSize="sm" 
                                    type="select" 
                                    value={rmdUom} 
                                    onChange={(e) => {
                                        setRmdUom(e.target.value); 
                                        setRmdUomTxt(e.target.selectedOptions[0].text)
                                    }}
                                    className="form-select"
                                >
                                    <option value="">--Select UOM--</option>
                                    <option value="0">--</option>
                                    <option value="1">Gm</option>
                                    <option value="2">Kg</option>
                                    <option value="3">Liter</option>
                                    <option value="4">Feet</option>
                                    <option value="5">Cm</option>
                                    <option value="6">Seeds</option>
                                    <option value="7">%</option>
                                </Input>
                            </Col>
                        </Row>
                        
                        {/* UOM Preview */}
                        {rmdUom && rmdUom !== "0" && (
                            <div className="bg-light p-3 rounded mb-3">
                                <div className="d-flex align-items-center gap-2">
                                    {getUomIcon(rmdUom)}
                                    <strong>Selected Unit:</strong>
                                    <Badge color="primary">{rmdUomTxt}</Badge>
                                </div>
                            </div>
                        )}

                        <hr className="my-4" />
                        <div className="d-flex justify-content-end gap-2">
                            <Button 
                                type="button"
                                color="secondary" 
                                size="sm"
                                onClick={() => setDetailModal(false)}
                                disabled={submitting}
                            >
                                Cancel
                            </Button>
                            <Button 
                                type="submit"
                                color='primary' 
                                size="sm"
                                disabled={submitting || !measureDtl || measureDtl === '0' || !rmdValue || !rmdUom}
                                className="d-flex align-items-center gap-2"
                            >
                                {submitting ? (
                                    <>
                                        <Spinner size="sm" />
                                        Adding...
                                    </>
                                ) : (
                                    <>
                                        <FaPlus size={14} />
                                        Add Detail
                                    </>
                                )}
                            </Button>
                        </div>
                    </Form>
                </ModalBody>
            </Modal>
        </>
    )
}

export default AddNewPOP;